export default __webpack_public_path__ + "dist/media/Reset.a90fb7d3.svg";